import copyToClipboard from "copy-to-clipboard";
import { DataGridRef } from "../types";
import { getSelectedRangeData } from "./copy";

function encodeCsvIden(str: string | number) {
    if (!str) {
        return '';
    }
    if (typeof str !== 'string') {
        str = str.toString()
    }
    return '"' + str.replace(/"/g, '""').replace(/\x00/g, '') + '"';
}

function exportCsv<R>(gridRefContext: DataGridRef<R>) {
    const rangeData = getSelectedRangeData(gridRefContext);
    if (!rangeData) {
        return;
    }

    copyToClipboard(
        rangeData.map((data) => {
            return data.map((item) => {
                return encodeCsvIden(item as any)
            }).join(',')
        }).join('\r\n'),
        {
            format: 'text/plain'
        }
    )
}

export default exportCsv;
